(() => {
  const P = () => window.MukhlisPricing;

  const money = (paise) => {
    if (P()) return P().money(paise);
    const rupees = Math.round(Number(paise) / 100) || 0;
    try {
      return `₹${rupees.toLocaleString('en-IN')}`;
    } catch {
      return `₹${rupees}`;
    }
  };

  const ADDON_MRP = 30000;
  const ADDON_PRICES = {
    takmeeli: { 2: 22000, 3: 20000, 4: 19000 },
    nutrinuts: { 2: 23000, 3: 21000, 4: 19000, 5: 17000, 6: 15000 },
  };

  class ProductFormController {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-product-form]');
      this.variantInput = root.querySelector('[name="id"]');
      this.qtyInput = root.querySelector('[data-qty-input]');
      this.priceEl = root.querySelector('[data-product-price]');
      this.errorEl = root.querySelector('[data-form-error]');
      this.addBtn = root.querySelector('[data-add-to-cart]');
      this.buyBtn = root.querySelector('[data-buy-now]');
      this.waBtn = root.querySelector('[data-whatsapp-order]');
      this.mobileAddBtn = root.querySelector('[data-mobile-add]');
      this.mobileBuyBtn = root.querySelector('[data-mobile-buy]');
      this.mainImage = root.querySelector('[data-main-image]');
      this.lockHero = root.dataset.lockHero === 'true';
      this.clearanceMode = root.dataset.clearance === 'true';
      this.comboChips = root.querySelector('[data-combo-chips]');
      this.comboSelect = root.querySelector('[data-combo-select]');
      this.flavourPanel = root.querySelector('[data-flavour-panel]');
      this.productTitle = root.dataset.productTitle || '';
      this.productUrl = root.dataset.hubUrl || root.dataset.productUrl || window.location.href;
      this.hubUrl = root.dataset.hubUrl || this.productUrl;
      this.whatsappNumber = root.dataset.whatsappNumber || '';
      this.whatsappPrefix = root.dataset.whatsappPrefix || 'Hi! I want to place an order:';
      this.comboFamily = this.parseJson('[data-combo-family]', []);
      if (!Array.isArray(this.comboFamily)) this.comboFamily = [];
      this.flavours = this.parseFlavours();
      const urlCombo = Number(new URLSearchParams(window.location.search).get('combo') || 0);
      let selectedCombo;
      if (this.clearanceMode) {
        // Always open clearance PDP on Combo of 4 (desktop + mobile)
        selectedCombo = 4;
      } else {
        const familyDefault = this.comboFamily.some((c) => Number(c.size) === 3) ? 3 : 0;
        selectedCombo = Number(
          urlCombo || root.dataset.comboSize || this.comboSelect?.value || familyDefault || 0
        );
      }
      this.selectedCombo = selectedCombo;
      this.flavoursByUnit = [[]];
      this.addonEnabled = root.dataset.productAddon === 'true' || root.dataset.takmeeliAddon === 'true';
      this.addonFamily = root.dataset.addonFamily || (root.dataset.takmeeliAddon === 'true' ? 'takmeeli' : '');
      this.addonProduct = this.parseJson('[data-addon-product]', null);
      this.addonOn = false;
      this.addonFlavour = '';
      this.basePrice = 0;
      this.baseCompare = 0;
      this._sprinkleRaf = 0;
      this._flavourMaps = {};
      this._flavourMapPromises = {};
      this.bind();
      this.renderComboChips();
      this.hydrateAddonFlavours();
      const startSize = this.clearanceMode
        ? 4
        : this.selectedCombo ||
          Number(this.comboSelect?.value || 0) ||
          (this.comboFamily[0] && this.comboFamily[0].size) ||
          0;
      if (startSize) {
        this.applyCombo(startSize, false);
      } else {
        this.hydrateSimplePricing();
        this.refreshTotals();
      }
      if (this.clearanceMode) {
        // Re-assert after init so mobile never stays on combo 3 from URL/cache
        this.applyCombo(4, false);
      }
      this.renderFlavourDropdowns();
      this.syncAddonUi(false);
      this.syncMobileBar();
    }

    /** Non-combo products (e.g. Care combo): read price/MRP from the buy box */
    hydrateSimplePricing() {
      const price = Number(this.priceEl?.dataset.price || 0);
      const compare = Number(this.priceEl?.dataset.compare || 0);
      if (price > 0) this.basePrice = price;
      if (compare > 0) this.baseCompare = compare;

      // Prefer live variant JSON when present
      const variant = this.parseJson('[data-selected-variant]', null);
      if (variant) {
        if (Number(variant.price) > 0) this.basePrice = Number(variant.price);
        if (Number(variant.compare_at_price) > 0) {
          this.baseCompare = Number(variant.compare_at_price);
        }
      }

      if (this.variantInput && !this.variantInput.value && variant?.id) {
        this.variantInput.value = String(variant.id);
      }
    }

    parseJson(sel, fallback) {
      const el = this.root.querySelector(sel);
      if (!el) return fallback;
      try {
        return JSON.parse(el.textContent.trim());
      } catch (err) {
        console.warn('Failed to parse', sel, err);
        return fallback;
      }
    }

    parseFlavours() {
      try {
        return JSON.parse(this.root.dataset.flavours || '[]');
      } catch {
        return [];
      }
    }

    qty() {
      return Math.max(1, Number(this.qtyInput?.value || 1));
    }

    addonOfferPrice() {
      if (P()) return P().addonOfferForCombo(this.addonFamily, this.selectedCombo);
      const table = ADDON_PRICES[this.addonFamily] || ADDON_PRICES.takmeeli;
      const size = Number(this.selectedCombo);
      return table[size] || table[2] || 0;
    }

    addonPrice() {
      if (!this.addonOn) return 0;
      return this.addonOfferPrice();
    }

    addonCompare() {
      if (!this.addonOn) return 0;
      return ADDON_MRP;
    }

    bind() {
      this.root.querySelectorAll('[data-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.lockHero) return;
          if (this.mainImage) this.mainImage.src = btn.getAttribute('data-thumb');
          this.root.querySelectorAll('[data-thumb]').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
      });

      const onQtyChange = () => {
        this.syncFlavourUnitsToQty();
        this.renderFlavourDropdowns();
        this.clearError();
        this.refreshTotals();
        this.syncMobileBar();
      };

      this.root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        this.qtyInput.value = Math.max(1, this.qty() - 1);
        onQtyChange();
      });
      this.root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        this.qtyInput.value = this.qty() + 1;
        onQtyChange();
      });
      this.qtyInput?.addEventListener('change', onQtyChange);
      this.qtyInput?.addEventListener('input', onQtyChange);

      this.comboSelect?.addEventListener('change', () => {
        this.applyCombo(Number(this.comboSelect.value), true);
      });

      this.comboChips?.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-combo-size]');
        if (!btn) return;
        e.preventDefault();
        this.applyCombo(Number(btn.getAttribute('data-combo-size')), true);
      });

      const goCart = (e) => {
        e.preventDefault();
        this.submit('cart');
      };
      const goBuy = (e) => {
        e.preventDefault();
        this.submit('checkout');
      };

      this.addBtn?.addEventListener('click', goCart);
      this.buyBtn?.addEventListener('click', goBuy);
      this.mobileAddBtn?.addEventListener('click', goCart);
      this.mobileBuyBtn?.addEventListener('click', goBuy);

      this.waBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.validate()) return;
        this.openWhatsApp();
      });

      this.root.querySelector('[data-addon-toggle]')?.addEventListener('change', (e) => {
        const wasOn = this.addonOn;
        this.addonOn = Boolean(e.target.checked);
        this.syncAddonUi(this.addonOn && !wasOn);
        this.refreshTotals();
        this.clearError();
      });

      this.root.querySelector('[data-addon-flavour]')?.addEventListener('change', (e) => {
        this.addonFlavour = e.target.value || '';
        this.clearError();
        this.refreshTotals();
      });
    }

    hydrateAddonFlavours() {
      const select = this.root.querySelector('[data-addon-flavour]');
      if (!select) return;

      let options = [...this.flavours];
      if (this.addonProduct?.variants?.length) {
        const fromVariants = this.addonProduct.variants
          .map((v) => {
            // Prefer Flavours option (first option), not Offer tier
            if (v.options && v.options[0]) return v.options[0];
            const selected = v.selected_options || v.selectedOptions || [];
            const flavourOpt = selected.find(
              (o) => /flavour/i.test(String(o.name || '')) || !/offer|combo/i.test(String(o.name || ''))
            );
            return (flavourOpt && flavourOpt.value) || v.title?.split('/')[0]?.trim();
          })
          .filter((t) => t && t !== 'Default Title' && !/^combo of\s+\d+$/i.test(String(t).trim()));
        const unique = [...new Set(fromVariants.map((t) => String(t).trim()))];
        if (unique.length) options = unique;
      }
      if (!options.length) {
        options =
          this.addonFamily === 'nutrinuts'
            ? this.nutriFlavourOrder()
            : ['Elaichi', 'Vanilla', 'Milk Mawa', 'Baby & Kids Milk Mawa'];
      } else if (this.addonFamily === 'nutrinuts') {
        options = options.map((f) => this.canonicalizeFlavourLabel(f));
        const order = this.nutriFlavourOrder();
        options.sort((a, b) => {
          const ia = order.indexOf(a);
          const ib = order.indexOf(b);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b);
        });
      }

      const current = select.value || '';
      select.innerHTML = [
        `<option value="">Select flavour</option>`,
        ...options.map((f) => `<option value="${f}">${f}</option>`),
      ].join('');
      if (current && options.includes(current)) select.value = current;
    }

    syncAddonUi(playCelebrate) {
      if (!this.addonEnabled) return;
      const body = this.root.querySelector('[data-addon-body]');
      const toggle = this.root.querySelector('[data-addon-toggle]');
      const label = this.root.querySelector('[data-addon-toggle-label]');
      const priceHint = this.root.querySelector('[data-addon-price-hint]');
      const sprinkles = this.root.querySelector('[data-addon-sprinkles]');

      if (toggle) toggle.checked = this.addonOn;
      if (body) body.hidden = !this.addonOn;
      if (label) label.textContent = this.addonOn ? 'Add-on added' : 'Add 1 pack';
      const offer = this.addonOfferPrice();
      if (priceHint) {
        priceHint.hidden = false;
        priceHint.innerHTML = this.addonOn
          ? `Included at <b>${money(offer)}</b> <span class="pdp-addon__mrp-hint">MRP ${money(ADDON_MRP)}</span>`
          : `Add on in just <b>${money(offer)}</b> <span class="pdp-addon__mrp-hint">MRP ${money(ADDON_MRP)}</span>`;
      }
      const offerPriceEl = this.root.querySelector('[data-addon-offer-price]');
      const mrpLabelEl = this.root.querySelector('[data-addon-mrp-label]');
      if (offerPriceEl) offerPriceEl.textContent = money(offer);
      if (mrpLabelEl) mrpLabelEl.textContent = `MRP ${money(ADDON_MRP)}`;

      this.root.querySelector('[data-addon]')?.classList.toggle('is-on', this.addonOn);

      if (this.addonOn && playCelebrate) {
        if (sprinkles) sprinkles.hidden = false;
        this.burstSprinkles();
        window.clearTimeout(this._sprinkleTimer);
        this._sprinkleTimer = window.setTimeout(() => {
          this.stopSprinkles();
        }, 2400);
      } else if (!this.addonOn) {
        this.stopSprinkles();
        const select = this.root.querySelector('[data-addon-flavour]');
        if (select) select.value = '';
        this.addonFlavour = '';
      }
    }

    burstSprinkles() {
      const canvas = this.root.querySelector('[data-addon-sprinkles]');
      if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const rect = canvas.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const colors = ['#0e5c4a', '#c4a35a', '#51ff88', '#f7f3ea', '#e8b84a', '#2d6a4f'];
      const pieces = Array.from({ length: 54 }, () => ({
        x: Math.random() * rect.width,
        y: -10 - Math.random() * 30,
        r: 2 + Math.random() * 3.5,
        vx: -1.8 + Math.random() * 3.6,
        vy: 1.6 + Math.random() * 3.2,
        rot: Math.random() * Math.PI,
        vr: -0.2 + Math.random() * 0.4,
        color: colors[Math.floor(Math.random() * colors.length)],
        life: 1,
      }));

      const start = performance.now();
      cancelAnimationFrame(this._sprinkleRaf);

      const tick = (now) => {
        const t = (now - start) / 1000;
        ctx.clearRect(0, 0, rect.width, rect.height);
        pieces.forEach((p) => {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += 0.08;
          p.rot += p.vr;
          p.life = Math.max(0, 1 - t / 2.2);
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.globalAlpha = p.life;
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.r, -p.r * 0.45, p.r * 2, p.r * 0.9);
          ctx.restore();
        });
        if (t < 2.3) this._sprinkleRaf = requestAnimationFrame(tick);
        else this.stopSprinkles();
      };

      this._sprinkleRaf = requestAnimationFrame(tick);
    }

    stopSprinkles() {
      cancelAnimationFrame(this._sprinkleRaf);
      const canvas = this.root.querySelector('[data-addon-sprinkles]');
      if (!canvas) return;
      canvas.hidden = true;
      const ctx = canvas.getContext('2d');
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    syncFlavourUnitsToQty() {
      const q = this.qty();
      while (this.flavoursByUnit.length < q) this.flavoursByUnit.push([]);
      this.flavoursByUnit = this.flavoursByUnit.slice(0, q).map((unit) => {
        const next = [...(unit || [])];
        while (next.length < this.selectedCombo) next.push('');
        return next.slice(0, this.selectedCombo);
      });
      this.ensureDefaultDistinctFlavours();
    }

    /** Fill pack flavours so each pack defaults to a different flavour. */
    defaultDistinctFlavours(count) {
      const n = Math.max(0, Number(count) || 0);
      const pool = Array.isArray(this.flavours) ? this.flavours.filter(Boolean) : [];
      if (!n || !pool.length) return Array.from({ length: n }, () => '');
      const out = [];
      for (let i = 0; i < n; i += 1) {
        const unused = pool.find((f) => !out.includes(f));
        out.push(unused || pool[i % pool.length]);
      }
      return out;
    }

    ensureDefaultDistinctFlavours(force = false) {
      if (!this.flavours?.length || !this.selectedCombo) return;
      this.flavoursByUnit = this.flavoursByUnit.map((unit) => {
        const current = Array.from({ length: this.selectedCombo }, (_, i) => unit?.[i] || '');
        const filled = current.filter(Boolean);
        const uniqueCount = new Set(filled).size;
        const hasEmpty = current.some((v) => !v);
        const hasDupes = filled.length > 0 && uniqueCount < filled.length;
        const shouldReset =
          force ||
          !filled.length ||
          hasEmpty ||
          (hasDupes && uniqueCount < Math.min(this.selectedCombo, this.flavours.length));

        if (!shouldReset) return current;
        return this.defaultDistinctFlavours(this.selectedCombo);
      });
    }

    clearanceDeal(size) {
      const n = Number(size);
      if (n === 3) {
        return {
          free: 1,
          totalPacks: 4,
          perPackLabel: '₹224.75',
          perPackPaise: 22475,
          sale: 89900,
          mrp: 90000,
          worth: 30000,
        };
      }
      if (n === 4) {
        return {
          free: 2,
          totalPacks: 6,
          perPackLabel: '₹200',
          perPackPaise: 20000,
          sale: 119900,
          mrp: 120000,
          worth: 60000,
        };
      }
      return null;
    }

    syncClearanceCopy() {
      if (!this.clearanceMode) return;
      const deal = this.clearanceDeal(this.selectedCombo);
      const sasta = this.root.querySelector('[data-clearance-sasta]');
      const packPrice = this.root.querySelector('[data-clearance-pack-price]');
      const freeNote = this.root.querySelector('[data-clearance-free-note]');
      if (!deal) return;
      if (sasta) {
        sasta.textContent = `सबसे सस्ता · ${deal.perPackLabel}/पैकेट`;
      }
      if (packPrice) {
        packPrice.textContent = `${deal.perPackLabel}/पैकेट · सबसे सस्ता`;
      }
      if (freeNote) {
        freeNote.innerHTML = `You pay for ${this.selectedCombo} · Get ${deal.totalPacks} · Free worth <b>${money(deal.worth)}</b>`;
      }
    }

    renderComboChips() {
      if (!this.comboChips) return;
      if (!this.comboFamily.length) {
        this.comboChips.innerHTML = '';
        return;
      }
      const sorted = [...this.comboFamily].sort((a, b) => Number(a.size) - Number(b.size));
      this.comboFamily = sorted;

      const saveUpTo = (item) => {
        if (this.clearanceMode) return 0;
        if (P()?.saveUpToPaise) {
          return P().saveUpToPaise({
            price: item.price,
            compareAt: item.compare_at_price,
            includeAddon: this.addonEnabled,
            family: this.addonFamily,
            comboSize: item.size,
          });
        }
        const sale = Number(item.price) || 0;
        const cmp = Number(item.compare_at_price) || 0;
        const mrpSave = cmp > sale ? cmp - sale : 0;
        let addonSale = 0;
        let addonSave = 0;
        if (this.addonEnabled) {
          const table = (P()?.ADDON_PRICES || ADDON_PRICES)[this.addonFamily] || ADDON_PRICES.takmeeli;
          addonSale = table[Number(item.size)] || table[2] || 0;
          const mrp = P()?.ADDON_MRP || ADDON_MRP;
          addonSave = mrp > addonSale ? mrp - addonSale : 0;
        }
        return Math.max(0, mrpSave + addonSave);
      };

      this.comboChips.innerHTML = sorted
        .map((item) => {
          const active = Number(item.size) === Number(this.selectedCombo);
          const popular = this.clearanceMode ? Number(item.size) === 4 : Number(item.size) === 3;
          const saveAmt = saveUpTo(item);
          const deal = this.clearanceMode ? this.clearanceDeal(item.size) : null;
          const saveHtml =
            !this.clearanceMode && saveAmt > 0
              ? `<span class="combo-chip__save"><span class="combo-chip__save-label">Save up to</span> <strong>${money(saveAmt)}</strong></span>`
              : '';
          const popularHtml = popular
            ? `<span class="combo-chip__ribbon" aria-label="Most popular">
                <span class="combo-chip__ribbon-shine" aria-hidden="true"></span>
                <span class="combo-chip__ribbon-spark" aria-hidden="true"></span>
                <span class="combo-chip__ribbon-text">Most popular</span>
              </span>`
            : '';
          if (deal) {
            return `
              <button type="button" class="combo-chip combo-chip--clearance${active ? ' is-active' : ''}${popular ? ' combo-chip--popular' : ''}" data-combo-size="${item.size}" role="radio" aria-checked="${active}">
                ${popularHtml}
                <span class="combo-chip__size">Combo of ${item.size}</span>
                <span class="combo-chip__price"><s>${money(deal.mrp)}</s> <b>${money(deal.sale)}</b></span>
                <span class="combo-chip__free"><svg class="combo-chip__gift" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg><span>+${deal.free} FREE packet${deal.free > 1 ? 's' : ''} · worth <b>${money(deal.worth)}</b></span></span>
                <span class="combo-chip__packs">Get ${deal.totalPacks} packs · pay for ${item.size}</span>
                <span class="combo-chip__perpack">${deal.perPackLabel}/पैकेट · <b>सबसे सस्ता</b></span>
              </button>
            `;
          }
          return `
            <button type="button" class="combo-chip${active ? ' is-active' : ''}${popular ? ' combo-chip--popular' : ''}" data-combo-size="${item.size}" role="radio" aria-checked="${active}">
              ${popularHtml}
              <span class="combo-chip__size">Combo of ${item.size}</span>
              <span class="combo-chip__packs">${item.size} × 250g</span>
              <span class="combo-chip__price">${money(item.price)}</span>
              ${saveHtml}
            </button>
          `;
        })
        .join('');

      // Keep native <select> labels in sync (fallback / a11y)
      if (this.comboSelect?.options?.length) {
        [...this.comboSelect.options].forEach((opt) => {
          const item = sorted.find((c) => String(c.size) === String(opt.value));
          if (!item) return;
          const saveAmt = saveUpTo(item);
          const deal = this.clearanceMode ? this.clearanceDeal(item.size) : null;
          opt.dataset.price = String(item.price);
          opt.dataset.compare = String(item.compare_at_price || 0);
          if (deal) {
            opt.textContent = `Combo of ${item.size} — ${money(deal.sale)} · +${deal.free} free (worth ${money(deal.worth)}) · सबसे सस्ता`;
          } else {
            opt.textContent =
              saveAmt > 0
                ? `Combo of ${item.size} — ${money(item.price)} · Save up to ${money(saveAmt)}`
                : `Combo of ${item.size} — ${money(item.price)}`;
          }
        });
      }
    }

    applyCombo(size, animate) {
      size = Number(size);
      if (!size) return;
      this.selectedCombo = size;

      if (this.comboSelect && String(this.comboSelect.value) !== String(size)) {
        this.comboSelect.value = String(size);
      }

      const item = this.comboFamily.find((c) => Number(c.size) === size);
      if (item && this.variantInput) {
        this.variantInput.value = item.variant_id;
        this.basePrice = Number(item.price) || 0;
        this.baseCompare = Number(item.compare_at_price) || 0;
        if (this.clearanceMode) {
          const deal = this.clearanceDeal(size);
          if (deal) {
            this.basePrice = deal.sale;
            this.baseCompare = deal.mrp;
          }
          // Always pin cart to clearance sale variants (₹899 / ₹1,199)
          this.variantInput.value = String(
            Number(size) === 3 ? 67921379426610 : 67921379459378
          );
        }
        if (item.image && this.mainImage && !this.lockHero) {
          this.mainImage.src = item.image;
          if (animate) {
            this.mainImage.classList.remove('is-swap');
            void this.mainImage.offsetWidth;
            this.mainImage.classList.add('is-swap');
          }
        }
        this.productUrl = this.hubUrl || this.productUrl;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('combo', String(size));
          window.history.replaceState({}, '', url.toString());
        } catch (_) {
          /* ignore */
        }
      } else if (this.comboSelect) {
        const opt = this.comboSelect.selectedOptions?.[0];
        if (opt?.dataset.variantId) this.variantInput.value = opt.dataset.variantId;
        this.basePrice = Number(opt?.dataset.price || 0);
        this.baseCompare = Number(opt?.dataset.compare || 0);
      }

      const label = this.root.querySelector('[data-flavour-count-label]');
      if (label) label.textContent = String(size);
      this.syncFlavourUnitsToQty();
      this.ensureDefaultDistinctFlavours(true);
      this.syncFlavoursFromActiveCombo();
      this.renderComboChips();
      this.syncClearanceCopy();
      this.renderFlavourDropdowns();
      this.hydrateAddonFlavours();
      this.syncAddonUi(false);
      this.refreshTotals();
      this.clearError();
      this.syncMobileBar();
    }

    optionHtml(selected) {
      return [
        `<option value="">Select flavour</option>`,
        ...this.flavours.map(
          (f) => `<option value="${f}" ${selected === f ? 'selected' : ''}>${f}</option>`
        ),
      ].join('');
    }

    renderFlavourDropdowns() {
      if (!this.flavourPanel || !this.flavours.length || !this.selectedCombo) {
        if (this.flavourPanel) this.flavourPanel.innerHTML = '';
        return;
      }
      this.syncFlavourUnitsToQty();
      const q = this.qty();

      this.flavourPanel.innerHTML = this.flavoursByUnit
        .map((unitFlavours, unitIndex) => {
          const packs = Array.from({ length: this.selectedCombo }, (_, packIndex) => {
            const value = unitFlavours[packIndex] || '';
            return `
              <label class="flavour-select">
                <span>Pack ${packIndex + 1}</span>
                <select data-unit="${unitIndex}" data-pack="${packIndex}" required>
                  ${this.optionHtml(value)}
                </select>
              </label>
            `;
          }).join('');

          return `
            <div class="flavour-unit" data-flavour-unit="${unitIndex}">
              ${q > 1 ? `<h3 class="flavour-unit__title">Quantity ${unitIndex + 1}</h3>` : ''}
              <div class="flavour-select-grid">${packs}</div>
            </div>
          `;
        })
        .join('');

      this.flavourPanel.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => {
          const unit = Number(select.getAttribute('data-unit'));
          const pack = Number(select.getAttribute('data-pack'));
          if (!this.flavoursByUnit[unit]) this.flavoursByUnit[unit] = [];
          this.flavoursByUnit[unit][pack] = select.value;
          this.clearError();
        });
      });
    }

    readFlavoursFromDom() {
      this.flavourPanel?.querySelectorAll('select').forEach((select) => {
        const unit = Number(select.getAttribute('data-unit'));
        const pack = Number(select.getAttribute('data-pack'));
        if (!this.flavoursByUnit[unit]) this.flavoursByUnit[unit] = [];
        this.flavoursByUnit[unit][pack] = select.value;
      });
      const addonFlavour = this.root.querySelector('[data-addon-flavour]');
      if (addonFlavour) this.addonFlavour = addonFlavour.value || '';
    }

    validate() {
      this.readFlavoursFromDom();
      if (this.flavours.length && this.selectedCombo > 0) {
        for (let u = 0; u < this.qty(); u += 1) {
          const unit = this.flavoursByUnit[u] || [];
          const filled = unit.filter(Boolean);
          if (filled.length !== this.selectedCombo) {
            this.showError(
              this.qty() > 1
                ? `Please select all ${this.selectedCombo} flavours for Quantity ${u + 1}.`
                : `Please select ${this.selectedCombo} flavour${this.selectedCombo > 1 ? 's' : ''} from the dropdowns.`
            );
            return false;
          }
        }
      }
      if (this.addonEnabled && this.addonOn) {
        if (!this.addonFlavour) {
          this.showError('Please select a flavour for your add-on pack.');
          return false;
        }
        if (!this.addonProduct?.variants?.length) {
          const addonName =
            this.addonFamily === 'nutrinuts'
              ? 'Nutri Nuts Talbeena Add on'
              : 'Takmeeli Talbeena Add on';
          this.showError(`Add-on product is not available yet. Please publish “${addonName}” (Active).`);
          return false;
        }
      }
      if (!this.variantInput?.value) {
        this.showError('Please select a combo.');
        return false;
      }
      return true;
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      this.errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }

    normalizeFlavour(value) {
      const raw = String(value || '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!raw) return '';
      if (raw.includes('baby')) return 'baby';
      if (raw.includes('milk') && raw.includes('mawa')) return 'milk mawa';
      if (raw.includes('mawa')) return 'milk mawa';
      if (raw.includes('elaichi') || raw.includes('elachi') || raw.includes('cardamom')) return 'elaichi';
      if (raw.includes('vanilla')) return 'vanilla';
      // Distinguish Kids vs Adults chocolate (Nutri Nuts)
      if (raw.includes('chocolate') && /\badults?\b/.test(raw)) return 'chocolate adults';
      if (raw.includes('chocolate') && /\bkids?\b/.test(raw)) return 'chocolate kids';
      if (raw.includes('chocolate')) return 'chocolate';
      if (raw.includes('mango') && /\bkids?\b/.test(raw)) return 'mango kids';
      if (raw.includes('mango')) return 'mango';
      if (raw.includes('butterscotch')) return 'butterscotch';
      if (raw.includes('strawberry')) return 'strawberry';
      return raw;
    }

    /** Prefer clean Nutri Nuts labels while keeping Shopify variant matching via normalizeFlavour */
    canonicalizeFlavourLabel(value) {
      const key = this.normalizeFlavour(value);
      const preferred = {
        elaichi: 'Elaichi',
        'chocolate kids': 'Chocolate for Kids',
        'chocolate adults': 'Chocolate for Adults',
        chocolate: 'Chocolate',
        'mango kids': 'Mango for Kids',
        mango: 'Mango',
        butterscotch: 'Butterscotch',
        strawberry: 'Strawberry',
        vanilla: 'Vanilla',
        'milk mawa': 'Milk Mawa',
        baby: 'Baby & Kids Milk Mawa',
      };
      if (preferred[key]) return preferred[key];
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    nutriFlavourOrder() {
      return [
        'Elaichi',
        'Chocolate for Kids',
        'Chocolate for Adults',
        'Strawberry',
        'Butterscotch',
        'Mango for Kids',
      ];
    }

    syncFlavoursFromActiveCombo() {
      if (this.addonFamily !== 'nutrinuts' && !String(this.productTitle || '').toLowerCase().includes('nutri')) {
        return;
      }
      const item = this.comboFamily.find((c) => Number(c.size) === Number(this.selectedCombo));
      if (!item?.variants?.length) return;

      const byKey = new Map();
      const ingestLabel = (raw) => {
        const label = String(raw || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!label || /^combo of\s+\d+$/i.test(label)) return;
        // Joined mixes (Talbeena-style): "Elaichi + Strawberry + …"
        if (label.includes('+') || label.includes('/')) {
          label.split(/[+/]/).forEach((part) => ingestLabel(part));
          return;
        }
        const key = this.normalizeFlavour(label);
        if (!key || byKey.has(key)) return;
        byKey.set(key, this.canonicalizeFlavourLabel(label));
      };

      item.variants.forEach((variant) => {
        if (Array.isArray(variant.options)) {
          variant.options.forEach((opt) => ingestLabel(opt));
        }
        if (variant.title && variant.title !== 'Default Title') {
          ingestLabel(variant.title);
        }
      });

      if (!byKey.size) return;

      const ordered = [];
      this.nutriFlavourOrder().forEach((name) => {
        const key = this.normalizeFlavour(name);
        if (byKey.has(key)) {
          ordered.push(byKey.get(key));
          byKey.delete(key);
        }
      });
      byKey.forEach((label) => ordered.push(label));
      this.flavours = ordered;
    }

    /** Shopify option value labels (must match Admin variant option names). */
    shopifyFlavourLabel(value) {
      const key = this.normalizeFlavour(value);
      const shopifyNames = {
        elaichi: 'Elaichi',
        vanilla: 'Vanilla',
        'milk mawa': 'Milk Mawa',
        baby: 'Baby',
        'chocolate kids': 'Chocolate for Kids',
        'chocolate adults': 'Chocolate for Adults',
        chocolate: 'Chocolate for Kids',
        'mango kids': 'Mango for Kids',
        mango: 'Mango for Kids',
        butterscotch: 'Butterscotch',
        strawberry: 'Strawberry',
      };
      if (shopifyNames[key]) return shopifyNames[key];
      return this.canonicalizeFlavourLabel(value);
    }

    /** Joined mix string written to the variant option → Admin LabelsContainer. */
    shopifyMixLabel(flavours) {
      return (flavours || [])
        .map((f) => this.shopifyFlavourLabel(f))
        .filter(Boolean)
        .join(' + ');
    }

    flavourMixLabel(flavours) {
      return (flavours || [])
        .map((f) => this.canonicalizeFlavourLabel(f))
        .filter(Boolean)
        .join(' + ');
    }

    mixKey(flavours) {
      return (flavours || [])
        .map((f) => this.normalizeFlavour(f))
        .filter(Boolean)
        .join('|');
    }

    mixParts(value) {
      return String(value || '')
        .split(/[+/|,]/)
        .map((p) => this.normalizeFlavour(p))
        .filter(Boolean);
    }

    variantMatchesMix(variant, wantedNorm) {
      if (!variant || !wantedNorm.length) return false;
      const fromOptions = (variant.options || []).flatMap((o) => this.mixParts(o));
      const fromTitle = this.mixParts(variant.title);
      const parts = fromOptions.length === wantedNorm.length ? fromOptions : fromTitle;
      if (parts.length !== wantedNorm.length) return false;
      return parts.every((p, i) => p === wantedNorm[i]);
    }

    /**
     * Match the Shopify variant from the customer's Pack dropdowns.
     * Admin LabelsContainer = Pack 1 / Pack 2 / Pack 3 option values.
     * All selected packs are also stored on the line item as Chosen flavours.
     * No external ensure server — works when the site is published.
     */
    async findMatchingVariant(comboItem, flavours) {
      const variants = comboItem?.variants || [];
      const fallback = () =>
        variants.find((v) => v.available !== false) || variants[0] || null;

      // Clearance sale uses fixed-price single variants — never match regular Talbeena SKUs.
      if (this.clearanceMode) {
        return fallback() || { id: comboItem?.variant_id, price: comboItem?.price, compare_at_price: comboItem?.compare_at_price };
      }

      const wantedAll = flavours.map((f) => this.normalizeFlavour(f)).filter(Boolean);
      if (!wantedAll.length) return fallback();

      const optionArity = Math.max(
        0,
        ...variants.map((v) => (Array.isArray(v.options) ? v.options.length : 0))
      );

      // Pack products (combo 2–6): match Pack 1..Pack N from the dropdowns.
      if (optionArity >= 2) {
        const matchLen = Math.min(wantedAll.length, optionArity, 3);
        const wanted = wantedAll.slice(0, Math.max(1, matchLen));
        const exact = variants.find((variant) => {
          const opts = (variant.options || []).map((o) => this.normalizeFlavour(o));
          if (opts.length < wanted.length) return false;
          return wanted.every((w, i) => opts[i] === w);
        });
        if (exact) return exact;
        return fallback();
      }

      // Single joined-option products (legacy): exact mix title if present.
      const mixLabel = this.shopifyMixLabel(flavours);
      const exactJoined = variants.find((variant) => {
        const title = String(variant.title || '').replace(/\s+/g, ' ').trim();
        const opt0 = String((variant.options || [])[0] || '')
          .replace(/\s+/g, ' ')
          .trim();
        return title === mixLabel || opt0 === mixLabel || this.variantMatchesMix(variant, wantedAll);
      });
      if (exactJoined) return exactJoined;

      return fallback();
    }

    /** Clearance only: lowercase name with collapsed spaces. */
    clearanceFlavourKey(name) {
      return String(name || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    /** Clearance only: "Elaichi x2 + Vanilla" → { elaichi: 2, vanilla: 1 } */
    clearanceOptionCountMap(value) {
      const map = {};
      String(value || '')
        .split('+')
        .forEach((raw) => {
          let name = String(raw || '').replace(/\s+/g, ' ').trim();
          if (!name) return;
          let count = 1;
          const m = name.match(/^(.*\S)\s+x\s*(\d+)$/i);
          if (m) {
            name = m[1];
            count = Number(m[2]) || 1;
          }
          const key = this.clearanceFlavourKey(name);
          map[key] = (map[key] || 0) + count;
        });
      return map;
    }

    /**
     * Clearance only: find the "Combo of N / <Flavours>" variant whose flavour counts
     * exactly match the Pack 1..N picks (order-independent). Returns null on no match
     * so the caller keeps the "Not selected" fallback id — never blocks the sale.
     */
    findClearanceFlavourVariant(unitFlavours) {
      if (!this.clearanceMode) return null;
      const size = Number(this.selectedCombo);
      const picks = (unitFlavours || []).filter(Boolean);
      if (!size || picks.length !== size) {
        console.warn('[clearance] Flavour picks do not fill the combo; using Not selected variant.', { size, picks });
        return null;
      }
      if (!this._clearanceVariants) {
        const all = this.parseJson('[data-variant-json]', []);
        this._clearanceVariants = Array.isArray(all) ? all : [];
      }
      const wanted = {};
      picks.forEach((f) => {
        const key = this.clearanceFlavourKey(f);
        wanted[key] = (wanted[key] || 0) + 1;
      });
      const wantedKeys = Object.keys(wanted);
      const comboKey = this.clearanceFlavourKey(`Combo of ${size}`);
      const match = this._clearanceVariants.find((v) => {
        const opt1 = v?.option1 ?? v?.options?.[0];
        const opt2 = v?.option2 ?? v?.options?.[1];
        if (this.clearanceFlavourKey(opt1) !== comboKey) return false;
        const have = this.clearanceOptionCountMap(opt2);
        const haveKeys = Object.keys(have);
        return haveKeys.length === wantedKeys.length && wantedKeys.every((k) => have[k] === wanted[k]);
      });
      if (!match) {
        console.warn('[clearance] No flavour variant matches picks; using Not selected variant.', { size, picks, wanted });
        return null;
      }
      if (match.available === false) {
        console.warn('[clearance] Matched flavour variant is unavailable; using Not selected variant.', match.id);
        return null;
      }
      return match;
    }

    async buildUnitPayload(unitIndex, bundleId = '') {
      const unitFlavours = (this.flavoursByUnit[unitIndex] || []).filter(Boolean);
      const comboItem = this.comboFamily.find((c) => Number(c.size) === Number(this.selectedCombo));
      const matched = await this.findMatchingVariant(comboItem, unitFlavours);
      let variantId = matched?.id || (unitFlavours.length ? null : comboItem?.variant_id || Number(this.variantInput.value));
      if (this.clearanceMode) {
        const deal = this.clearanceDeal(this.selectedCombo);
        variantId = Number(comboItem?.variant_id || matched?.id || 0) || variantId;
        if (!variantId && deal) {
          variantId = Number(this.selectedCombo) === 3 ? 67921379426610 : 67921379459378;
        }
        // Flavour mix as a variant so the courier label prints it; keeps "Not selected" id on no match.
        const flavourVariant = this.findClearanceFlavourVariant(unitFlavours);
        if (flavourVariant?.id) variantId = Number(flavourVariant.id);
      }
      if (!variantId) {
        throw new Error('Could not add this combo. Please refresh and try again.');
      }

      const properties = {};
      if (this.selectedCombo) properties.Combo = `Combo of ${this.selectedCombo}`;
      if (this.clearanceMode) {
        const deal = this.clearanceDeal(this.selectedCombo);
        if (deal) {
          properties['Free packets'] = String(deal.free);
          properties['Total packs'] = String(deal.totalPacks);
          properties.Offer = `Combo of ${this.selectedCombo} + ${deal.free} free · सबसे सस्ता`;
          properties['Per pack'] = `${deal.perPackLabel}/पैकेट`;
          properties['Sale price'] = money(deal.sale);
        }
      }
      if (bundleId) properties._bundle = bundleId;
      if (!this.isSimpleProduct() && this.qty() > 1) {
        properties.Set = `Quantity ${unitIndex + 1} of ${this.qty()}`;
      }
      if (unitFlavours.length) {
        properties.Flavours = unitFlavours
          .map((f, i) => `${i + 1}. ${this.shopifyFlavourLabel(f)}`)
          .join(' → ');
        properties['Chosen flavours'] = this.shopifyMixLabel(unitFlavours);
      }
      unitFlavours.forEach((flavour, i) => {
        properties[`Flavour ${i + 1}`] = this.shopifyFlavourLabel(flavour);
      });

      const unitPrice =
        this.clearanceMode && this.clearanceDeal(this.selectedCombo)
          ? this.clearanceDeal(this.selectedCombo).sale
          : Number(matched?.price ?? comboItem?.price) || Number(this.basePrice) || 0;
      const unitCompare =
        this.clearanceMode && this.clearanceDeal(this.selectedCombo)
          ? this.clearanceDeal(this.selectedCombo).mrp
          : Number(matched?.compare_at_price ?? comboItem?.compare_at_price) ||
            Number(this.baseCompare) ||
            0;

      if (unitIndex === 0) {
        const comboCmp = unitCompare > unitPrice ? unitCompare : 0;
        properties._order = JSON.stringify({
          price: Math.round(unitPrice / 100),
          mrp: Math.round(comboCmp / 100),
          qty: this.qty(),
          addon: this.addonOn,
          addonPrice: this.addonOn ? Math.round(this.addonOfferPrice() / 100) : 0,
          addonMrp: this.addonOn ? Math.round(ADDON_MRP / 100) : 0,
        });
      }

      return {
        id: Number(variantId),
        quantity: this.isSimpleProduct() ? this.qty() : 1,
        properties,
      };
    }

    findAddonVariant() {
      const variants = this.addonProduct?.variants || [];
      if (!variants.length) return null;
      const wantedFlavour = this.normalizeFlavour(this.addonFlavour);
      const offerLabel = `Combo of ${this.selectedCombo}`;
      const offerPaise = this.addonOfferPrice();

      const optionValues = (variant) => {
        const fromOptions = (variant.options || []).map((o) => String(o || ''));
        const fromSelected = (variant.selected_options || variant.selectedOptions || []).map(
          (o) => String(o.value || o || '')
        );
        return [...fromOptions, ...fromSelected, String(variant.title || '')];
      };

      const matchesFlavour = (variant) => {
        const parts = optionValues(variant).map((v) => this.normalizeFlavour(v));
        return parts.some(
          (p) => p && (p === wantedFlavour || p.includes(wantedFlavour) || wantedFlavour.includes(p))
        );
      };

      const matchesOffer = (variant) => {
        const parts = optionValues(variant).map((v) => v.toLowerCase());
        const needle = offerLabel.toLowerCase();
        if (parts.some((p) => p === needle || p.includes(needle))) return true;
        return Number(variant.price) === Number(offerPaise);
      };

      const flavoured = variants.filter(matchesFlavour);
      const pool = flavoured.length ? flavoured : variants;

      const exact = pool.find((v) => matchesOffer(v) && matchesFlavour(v));
      if (exact) return exact;

      const byOffer = pool.find(matchesOffer);
      if (byOffer) return byOffer;

      const byPrice = pool.find((v) => Number(v.price) === Number(offerPaise));
      if (byPrice) return byPrice;

      return pool.find((v) => v.available) || pool[0] || null;
    }

    isSimpleProduct() {
      return !this.selectedCombo && !this.comboFamily.length && !this.flavours.length;
    }

    newBundleId() {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      return `b-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }

    buildAddonPayload(bundleId = '') {
      if (!this.addonOn) return null;
      const variant = this.findAddonVariant();
      if (!variant?.id) return null;
      const offerInr = Math.round(this.addonOfferPrice() / 100);
      const mrpInr = Math.round(ADDON_MRP / 100);
      const properties = {
        // Only details on Buy now / checkout — prices stay private
        'Linked combo': `Combo of ${this.selectedCombo}`,
        Flavour: this.addonFlavour,
        _addon: '1',
        _prices: JSON.stringify({ offer: offerInr, mrp: mrpInr }),
      };
      if (bundleId) properties._bundle = bundleId;
      return {
        id: Number(variant.id),
        quantity: 1,
        properties,
      };
    }

    orderTotals() {
      const comboPrice = Number(this.basePrice) || 0;
      const compare = Number(this.baseCompare) || 0;
      const addonUnit = this.addonPrice();
      const addonCompare = this.addonCompare();
      const total = comboPrice * this.qty() + addonUnit;
      const savings = P()
        ? P().orderSavings({
            comboPrice,
            comboCompare: compare,
            qty: this.qty(),
            addonOn: this.addonOn,
            addonOffer: addonUnit,
            addonMrp: addonCompare,
          })
        : 0;
      const comboCmp = compare > comboPrice ? compare : 0;
      const totalCompare = comboCmp * this.qty() + (this.addonOn ? addonCompare : 0);
      return { total, totalCompare, savings };
    }

    /**
     * Mirror line-item properties onto the product form as properties[Key]
     * so FlexyPe's form scraper (yr/mr) can read them when they wire Buy Now.
     */
    syncCheckoutForm(primaryItem) {
      if (!this.form || !primaryItem) return;
      if (this.variantInput && primaryItem.id) {
        this.variantInput.value = String(primaryItem.id);
        this.variantInput.disabled = false;
      }
      this.form.querySelectorAll('[data-mukhlis-checkout-prop]').forEach((el) => el.remove());
      const props = primaryItem.properties || {};
      Object.entries(props).forEach(([key, value]) => {
        if (value == null || value === '') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = String(value);
        input.setAttribute('data-mukhlis-checkout-prop', '1');
        this.form.appendChild(input);
      });
    }

    mapItemsForFlexy(items) {
      return (items || []).map((item) => {
        const mapped = {
          variant_id: Number(item.id),
          quantity: Number(item.quantity) || 1,
        };
        if (item.properties && typeof item.properties === 'object' && Object.keys(item.properties).length) {
          mapped.properties = { ...item.properties };
        }
        return mapped;
      });
    }

    async fetchCart() {
      try {
        const res = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!res.ok) return null;
        return await res.json();
      } catch {
        return null;
      }
    }

    isFlexyCheckoutReady() {
      return (
        typeof window.openFlexyCheckout === 'function' && window.flexypeCheckoutActive === true
      );
    }

    /**
     * After cart/add: expose full handoff for FlexyPe.
     * If Flexy is live → open their checkout with variant/qty/properties.
     * Otherwise → native Shopify /checkout (current behaviour).
     */
    async goToCheckout(items, addResponse) {
      const primary = items[0];
      this.syncCheckoutForm(primary);
      const cart = await this.fetchCart();
      const flexyItems = this.mapItemsForFlexy(items);

      const handoff = {
        flow: 'buynow',
        source: 'mukhlis-product-form',
        items: flexyItems,
        cart,
        addResponse: addResponse || null,
        attributes: cart?.attributes || {},
        note: cart?.note || '',
        token: cart?.token || '',
        item_count: cart?.item_count ?? flexyItems.length,
        total_price: cart?.total_price,
        currency: cart?.currency,
        createdAt: Date.now(),
      };
      window.MukhlisCheckoutHandoff = handoff;
      document.dispatchEvent(new CustomEvent('mukhlis:checkout-ready', { detail: handoff }));

      if (this.isFlexyCheckoutReady()) {
        // FlexyPe openFlexyCheckout(source, session, items, addPromise)
        // Pass already-completed add so they do not rely on a bare form scrape.
        const addPromise = Promise.resolve(addResponse || cart || { items: flexyItems });
        window.openFlexyCheckout('buy_now_button', undefined, flexyItems, addPromise);
        return;
      }

      window.location.href = '/checkout';
    }

    async submit(mode) {
      if (!this.validate()) return;
      this.setLoading(true);
      try {
        const items = [];
        const bundleId = this.addonOn && this.selectedCombo ? this.newBundleId() : '';
        if (this.isSimpleProduct()) {
          items.push(await this.buildUnitPayload(0, bundleId));
        } else {
          for (let u = 0; u < this.qty(); u += 1) {
            items.push(await this.buildUnitPayload(u, bundleId));
          }
        }
        const addonItem = this.buildAddonPayload(bundleId);
        if (this.addonOn && !addonItem) {
          throw new Error('Could not match add-on flavour. Please choose another flavour.');
        }
        if (addonItem) items.push(addonItem);

        // Keep form in sync before add so FlexyPe form readers see the real variant + properties.
        this.syncCheckoutForm(items[0]);

        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          const msg =
            errBody.description ||
            errBody.message ||
            (String(errBody.status || '').includes('stock')
              ? 'Add-on pack is out of stock. Please try another flavour.'
              : 'Could not add to cart');
          throw new Error(msg);
        }
        const addResponse = await res.json();
        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (mode === 'checkout') {
          await this.goToCheckout(items, addResponse);
          return;
        }

        const totals = this.orderTotals();
        const flavours = items[0]?.properties?.Flavours;
        let message = flavours ? `${this.productTitle} — ${flavours}` : `${this.productTitle} added to cart.`;
        if (this.addonOn) {
          message += this.addonFlavour ? ` · Add-on: ${this.addonFlavour}` : ' · Add-on included';
        }

        document.dispatchEvent(
          new CustomEvent('cart:confirm', {
            detail: {
              message,
              totalFormatted: money(totals.total),
              mrpFormatted: totals.totalCompare > totals.total ? money(totals.totalCompare) : '',
              savingsFormatted: totals.savings > 0 ? money(totals.savings) : '',
            },
          })
        );
      } catch (err) {
        this.showError(err.message || 'Something went wrong.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(state) {
      [this.addBtn, this.buyBtn, this.waBtn, this.mobileAddBtn, this.mobileBuyBtn].forEach((btn) => {
        if (btn) btn.disabled = state;
      });
    }

    refreshTotals() {
      this.renderPrice(this.basePrice, this.baseCompare);
    }

    renderPrice(priceCents, compareCents) {
      let comboPrice = Number(priceCents) || 0;
      let compare = Number(compareCents) || 0;

      // Never wipe a valid buy-box price with zeros (care/simple products)
      if (!comboPrice && Number(this.priceEl?.dataset.price) > 0) {
        comboPrice = Number(this.priceEl.dataset.price);
        this.basePrice = comboPrice;
      }
      if (!compare && Number(this.priceEl?.dataset.compare) > 0) {
        compare = Number(this.priceEl.dataset.compare);
        this.baseCompare = compare;
      }

      const addonUnit = this.addonPrice();
      const addonCompare = this.addonCompare();
      const total = comboPrice * this.qty() + addonUnit;
      const comboCmp = compare > comboPrice ? compare : 0;
      const totalCompare = comboCmp * this.qty() + (this.addonOn ? addonCompare : 0);
      const showTotal = this.qty() > 1 || this.addonOn;
      const displaySale = showTotal ? total : comboPrice;
      const displayCompare = showTotal ? totalCompare : comboCmp;

      // Same “Save up to” as combo chips: MRP + add-on (max); no prepaid offer on Talbeena
      const saveUpToAmt = this.clearanceMode
        ? 0
        : P()?.saveUpToPaise
        ? P().saveUpToPaise({
            price: comboPrice,
            compareAt: compare,
            includeAddon: this.addonEnabled,
            family: this.addonFamily,
            comboSize: this.selectedCombo || Number(this.comboSelect?.value) || 2,
            qty: this.qty(),
          })
        : Math.max(0, comboCmp > 0 ? (comboCmp - comboPrice) * this.qty() : 0);

      const hasMrpSave = displayCompare > displaySale;
      const hasSaveUpTo = !this.clearanceMode && saveUpToAmt > 0;

      if (!this.priceEl) return;

      const saleEl = this.priceEl.querySelector('[data-price-sale]');
      const mrpEl = this.priceEl.querySelector('[data-price-mrp]');
      const saveEl = this.priceEl.querySelector('[data-price-save]');
      const savePctEl = this.priceEl.querySelector('[data-save-pct]');
      const saveAmtEl = this.priceEl.querySelector('[data-save-amt]');
      const noteEl = this.priceEl.querySelector('[data-price-breakdown]');
      const specialEl = this.priceEl.querySelector('[data-price-special-label]');

      this.priceEl.dataset.price = String(comboPrice);
      this.priceEl.dataset.compare = String(compare);
      this.priceEl.classList.toggle('pdp__price--deal', this.clearanceMode ? hasMrpSave : hasMrpSave || hasSaveUpTo);

      if (saleEl) saleEl.textContent = money(displaySale);
      if (specialEl) specialEl.hidden = !hasMrpSave || this.clearanceMode;

      if (hasMrpSave) {
        if (mrpEl) {
          mrpEl.hidden = false;
          mrpEl.textContent = money(displayCompare);
        }
      } else if (mrpEl) {
        mrpEl.hidden = true;
      }

      if (saveEl) {
        if (hasSaveUpTo) {
          saveEl.hidden = false;
          if (saveAmtEl) saveAmtEl.textContent = money(saveUpToAmt);
          // Composite “up to” (MRP + add-on) — hide simple % badge
          if (savePctEl) {
            const pctWrap = savePctEl.closest('.pdp__price-save-pct');
            if (pctWrap) pctWrap.hidden = true;
            else savePctEl.textContent = '';
          }
        } else {
          saveEl.hidden = true;
        }
      }

      if (noteEl) {
        if (this.addonOn || this.qty() > 1) {
          noteEl.hidden = false;
          const unitLabel = this.isSimpleProduct() ? 'Set' : 'Combo';
          const comboLabel = this.qty() > 1
            ? `${unitLabel} ${money(comboPrice)} × ${this.qty()}`
            : `${unitLabel} ${money(comboPrice)}`;
          const comboMrpBit =
            comboCmp > comboPrice
              ? ` <span class="pdp__break-mrp">MRP ${money(comboCmp * this.qty())}</span>`
              : '';
          if (this.addonOn) {
            noteEl.innerHTML = `
              <span class="pdp__break-chip">${comboLabel}${comboMrpBit}</span>
              <span class="pdp__break-plus">+</span>
              <span class="pdp__break-chip">Add-on ${money(addonUnit)} <span class="pdp__break-mrp">MRP ${money(addonCompare)}</span></span>
              <span class="pdp__break-eq">=</span>
              <span class="pdp__break-chip pdp__break-chip--total">${money(total)}</span>`;
          } else {
            noteEl.innerHTML = `<span class="pdp__break-chip">${comboLabel}${comboMrpBit}</span>
              <span class="pdp__break-eq">=</span>
              <span class="pdp__break-chip pdp__break-chip--total">${money(total)}</span>`;
          }
        } else if (this.isSimpleProduct() && hasMrpSave && this.qty() > 1) {
          noteEl.hidden = false;
          noteEl.innerHTML = `<span class="pdp__break-chip">Set ${money(comboPrice)} × ${this.qty()}</span>
            <span class="pdp__break-eq">=</span>
            <span class="pdp__break-chip pdp__break-chip--total">${money(total)} <span class="pdp__break-mrp">MRP ${money(totalCompare)}</span></span>`;
        } else {
          noteEl.hidden = true;
          noteEl.innerHTML = '';
        }
      }

      const mobile = this.root.querySelector('[data-mobile-price]');
      if (mobile) {
        const mobileMrp = mobile.querySelector('[data-mobile-mrp]');
        const mobileSale = mobile.querySelector('[data-mobile-sale]');
        const mobileSave = mobile.querySelector('[data-mobile-save]');
        const mobileSaveAmt = mobile.querySelector('[data-mobile-save-amt]');
        if (mobileSale) mobileSale.textContent = money(displaySale);
        if (mobileMrp) {
          if (hasMrpSave) {
            mobileMrp.hidden = false;
            mobileMrp.textContent = money(displayCompare);
          } else {
            mobileMrp.hidden = true;
          }
        }
        if (mobileSave) {
          if (hasSaveUpTo) {
            mobileSave.hidden = false;
            if (mobileSaveAmt) mobileSaveAmt.textContent = money(saveUpToAmt);
          } else {
            mobileSave.hidden = true;
          }
        }
      }
    }

    syncMobileBar() {
      const bar = this.root.querySelector('[data-mobile-cta]');
      if (!bar) return;
      document.body.classList.add('has-mobile-cta');
      const freeEl = bar.querySelector('[data-mobile-free]');
      const deal = this.clearanceMode ? this.clearanceDeal(this.selectedCombo) : null;
      if (freeEl && deal) freeEl.textContent = `+${deal.free} FREE (${money(deal.worth)})`;
      this.refreshTotals();
    }

    openWhatsApp() {
      this.readFlavoursFromDom();
      const item = this.comboFamily.find((c) => Number(c.size) === Number(this.selectedCombo));
      const flavourLines = this.flavoursByUnit.map((unit, i) => {
        const label = this.qty() > 1 ? `Qty ${i + 1}` : 'Flavours';
        return `${label}: ${(unit || []).filter(Boolean).join(', ')}`;
      });
      const lines = [
        this.whatsappPrefix,
        `Product: ${this.productTitle}`,
        this.selectedCombo ? `Combo: ${this.selectedCombo}` : '',
        `Quantity: ${this.qty()}`,
        ...flavourLines,
        item ? `Combo price: ${money(item.price)}` : '',
      ];
      if (this.addonOn) {
        lines.push(
          `Add-on: ${this.addonProduct?.title || (this.addonFamily === 'nutrinuts' ? 'Nutri Nuts Talbeena Add on' : 'Takmeeli Talbeena Add on')}`,
          `Add-on flavour: ${this.addonFlavour}`,
          `Add-on offer price: ${money(this.addonOfferPrice())} (MRP ${money(ADDON_MRP)})`
        );
      }
      const totals = this.orderTotals();
      lines.push(`Order total: ${money(totals.total)}`);
      if (totals.savings > 0) lines.push(`You save: ${money(totals.savings)}`);
      lines.push(`Link: ${this.productUrl}`);
      window.open(
        `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(lines.filter(Boolean).join('\n'))}`,
        '_blank',
        'noopener'
      );
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-root]').forEach((root) => new ProductFormController(root));
  });
})();
